

<!-- Rezervasyon Özeti - Sayfa Üstü -->
<div class="booking-summary-top" *ngIf="bookingSummary">
  <div class="container">
    <div class="bst-card">

      <!-- Sol: Özet -->
      <div class="bst-main">
        <!-- Üst: Otel + Tarih + Kişi -->
        <div class="bst-top">
          <h3 class="bst-hotel-name">{{ bookingSummary.hotelName }}</h3>
          <div class="bst-info-row">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>{{ formatShortDate(bookingSummary.checkIn) }} - {{ formatShortDate(bookingSummary.checkOut) }} · {{ getNightCount() }} Gece</span>
          </div>
          <div class="bst-info-row">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>{{ bookingSummary.adultCount }} Yetişkin<span *ngIf="bookingSummary.childCount">, {{ bookingSummary.childCount }} Çocuk</span><span *ngIf="bookingSummary.roomCount"> · {{ bookingSummary.roomCount }} Oda</span></span>
          </div>
        </div>

        <!-- Alt: Oda -->
        <div class="bst-room" *ngIf="bookingSummary.roomType">
          <h4 class="bst-room-title">{{ bookingSummary.roomType }}</h4>
          <div class="bst-room-body">
            <div class="bst-room-img" *ngIf="bookingSummary.hotelImage">
              <img [src]="bookingSummary.hotelImage" [alt]="bookingSummary.roomType"
                   (error)="bookingSummary.hotelImage = ''">
            </div>
            <div class="bst-room-info">
              <div class="bst-room-meal" *ngIf="bookingSummary.mealType">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>
                <span>{{ bookingSummary.mealType }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sağ: Fiyat -->
      <div class="bst-price" *ngIf="currentTotalPrice">
        <span class="bst-price__label">Toplam</span>
        <div class="bst-price__amount">{{ currentTotalPrice | currency : 'TRY' : 'symbol' : '1.0-0' }}</div>
        <div class="bst-price__old" *ngIf="addonBasePrice?.value && addonBasePrice.value > currentTotalPrice">
          <span class="bst-price__original">{{ addonBasePrice.value | currency : 'TRY' : 'symbol' : '1.0-0' }}</span>
          <span class="bst-price__save">−{{ getDiscountPercent() }}%</span>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="container" style="padding-top: 30px; padding-bottom: 60px;">
  <div class="row">

    <!-- Sol: Formlar -->
    <div class="col-xl-8 col-lg-7">
      <form [formGroup]="passengerForm" (ngSubmit)="onSubmit()">

        <!-- İletişim Bilgileri (En Üst) -->
        <div class="form-section" formArrayName="passengers">
          <div [formGroupName]="0">
            <div class="form-section__header">
              <div class="form-section__icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </div>
              <div>
                <h3 class="form-section__title">İletişim Bilgileri</h3>
                <p class="form-section__desc">Rezervasyon onayı bu bilgilere gönderilecektir.</p>
              </div>
            </div>

            <div class="row y-gap-20">
              <div class="col-md-6">
                <div class="form-input">
                  <input type="email" formControlName="email" required>
                  <label class="lh-1 text-16 text-light-1">E-posta Adresi <span class="text-red-1">*</span></label>
                </div>
                <div *ngIf="passengersArray.at(0).get('email')?.touched && passengersArray.at(0).get('email')?.errors"
                  class="text-red-1 text-14 mt-5">
                  Geçerli bir e-posta adresi giriniz.
                </div>
              </div>

              <div class="col-md-6" formGroupName="phoneNumbers">
                <div *ngFor="let phone of getPassengerPhoneNumbers(0).controls; let j = index" [formGroupName]="j">
                  <div class="form-input phone-input-group">
                    <span class="phone-prefix">+90</span>
                    <input type="tel" formControlName="number" required maxlength="10">
                    <label class="lh-1 text-16 text-light-1">Telefon Numarası <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="phone.get('number')?.touched && phone.get('number')?.errors"
                    class="text-red-1 text-14 mt-5">
                    Geçerli bir telefon numarası giriniz.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Yolcu Bilgileri -->
        <div class="form-section" formArrayName="passengers">
          <div class="form-section__header">
            <div class="form-section__icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <div>
              <h3 class="form-section__title">Yolcu Bilgileri</h3>
              <p class="form-section__desc">Tüm yolcuların kimlik bilgilerini eksiksiz doldurunuz.</p>
            </div>
          </div>

          <div *ngFor="let passenger of passengersArray.controls; let i = index" [formGroupName]="i">
            <div class="passenger-card" [class.passenger-card--first]="i === 0">
              <div class="passenger-card__header">
                <span class="passenger-card__badge">{{ getPassengerLabel(i) }}</span>
                <div class="saved-passenger-picker" *ngIf="savedPassengers.length > 0">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                  <span class="saved-passenger-picker__label">Kayıtlı kişiden seç</span>
                  <div class="saved-passenger-picker__select-wrap">
                    <select class="saved-passenger-picker__select"
                            [value]="selectedSavedByIndex[i] ?? ''"
                            (change)="applySavedPassenger(i, $any($event.target).value)">
                      <option value="">Kişi seçin...</option>
                      <option *ngFor="let sp of savedPassengers"
                              [value]="sp.id"
                              [disabled]="isPassengerUsedElsewhere(sp.id, i)">
                        {{ sp.firstName }} {{ sp.lastName }}{{ sp.isSelf ? ' (Kendim)' : '' }}{{ isPassengerUsedElsewhere(sp.id, i) ? ' — seçildi' : '' }}
                      </option>
                    </select>
                    <svg class="saved-passenger-picker__chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                  </div>
                </div>
              </div>

              <div class="row y-gap-20">
                <div class="col-md-6">
                  <div class="form-input">
                    <input type="text" formControlName="name" required>
                    <label class="lh-1 text-16 text-light-1">Ad <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="passenger.get('name')?.touched && passenger.get('name')?.errors"
                    class="text-red-1 text-14 mt-5">Ad alanı zorunludur (en az 2 karakter).</div>
                </div>

                <div class="col-md-6">
                  <div class="form-input">
                    <input type="text" formControlName="surname" required>
                    <label class="lh-1 text-16 text-light-1">Soyad <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="passenger.get('surname')?.touched && passenger.get('surname')?.errors"
                    class="text-red-1 text-14 mt-5">Soyad alanı zorunludur (en az 2 karakter).</div>
                </div>

                <div class="col-md-4">
                  <div class="form-input">
                    <input type="text" formControlName="tcKimlikNo" maxlength="11" required>
                    <label class="lh-1 text-16 text-light-1">TC Kimlik No <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="passenger.get('tcKimlikNo')?.touched && passenger.get('tcKimlikNo')?.errors"
                    class="text-red-1 text-14 mt-5">Geçerli bir TC Kimlik No giriniz (11 haneli).</div>
                </div>

                <div class="col-md-4">
                  <div class="form-input">
                    <input type="date" formControlName="birthday" required>
                    <label class="lh-1 text-16 text-light-1">Doğum Tarihi <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="passenger.get('birthday')?.touched && passenger.get('birthday')?.errors"
                    class="text-red-1 text-14 mt-5">Doğum tarihi zorunludur.</div>
                </div>

                <div class="col-md-4">
                  <div class="form-input">
                    <select formControlName="gender" required>
                      <option [ngValue]="null" disabled selected>Seçiniz</option>
                      <option [ngValue]="0">Erkek</option>
                      <option [ngValue]="1">Kadın</option>
                    </select>
                    <label class="lh-1 text-16 text-light-1">Cinsiyet <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="passenger.get('gender')?.touched && passenger.get('gender')?.errors"
                    class="text-red-1 text-14 mt-5">Cinsiyet seçimi zorunludur.</div>
                </div>

                <!-- Adres sadece 1. yolcu -->
                <div class="col-md-8" *ngIf="i === 0" formGroupName="address">
                  <div class="form-input">
                    <input type="text" formControlName="street" required>
                    <label class="lh-1 text-16 text-light-1">Adres <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="passenger.get('address.street')?.touched && passenger.get('address.street')?.errors"
                    class="text-red-1 text-14 mt-5">Adres alanı zorunludur.</div>
                </div>
                <div class="col-md-4" *ngIf="i === 0" formGroupName="address">
                  <div class="form-input">
                    <input type="text" formControlName="postalCode" maxlength="5" required>
                    <label class="lh-1 text-16 text-light-1">Posta Kodu <span class="text-red-1">*</span></label>
                  </div>
                  <div *ngIf="passenger.get('address.postalCode')?.touched && passenger.get('address.postalCode')?.errors"
                    class="text-red-1 text-14 mt-5">Geçerli bir posta kodu giriniz (5 haneli).</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Kurumsal Fatura -->
        <div class="form-section">
          <div class="form-section__header">
            <div class="form-section__icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/></svg>
            </div>
            <div>
              <h3 class="form-section__title">Fatura Bilgileri</h3>
              <p class="form-section__desc">Bireysel fatura bilgileri yolcu kimliğinden alınır. Kurumsal fatura istiyorsanız aşağıdan seçin.</p>
            </div>
          </div>

          <label class="corp-invoice-toggle">
            <input type="checkbox" [(ngModel)]="wantsCorporateInvoice" [ngModelOptions]="{standalone: true}" (change)="onCorporateInvoiceToggle()" />
            <span>Kurumsal fatura istiyorum</span>
          </label>

          <div *ngIf="wantsCorporateInvoice" class="corp-invoice-body">
            <div class="corp-invoice-picker" *ngIf="invoiceProfiles.length > 0">
              <label class="text-14 fw-500 mr-10">Kayıtlı profil:</label>
              <select class="saved-passenger-picker__select"
                      [value]="selectedInvoiceProfileId ?? ''"
                      (change)="applyInvoiceProfile($any($event.target).value)">
                <option value="">-- Seçin --</option>
                <option *ngFor="let ip of invoiceProfiles" [value]="ip.id">
                  {{ ip.title }} — {{ ip.companyName }}
                </option>
              </select>
            </div>

            <div class="row y-gap-15">
              <div class="col-md-6">
                <div class="form-input">
                  <input type="text" [(ngModel)]="corpInvoice.companyName" [ngModelOptions]="{standalone: true}" required>
                  <label class="lh-1 text-16 text-light-1">Firma Ünvanı <span class="text-red-1">*</span></label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-input">
                  <input type="text" [(ngModel)]="corpInvoice.taxOffice" [ngModelOptions]="{standalone: true}" required>
                  <label class="lh-1 text-16 text-light-1">Vergi Dairesi <span class="text-red-1">*</span></label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-input">
                  <input type="text" [(ngModel)]="corpInvoice.taxNumber" [ngModelOptions]="{standalone: true}" maxlength="11" required>
                  <label class="lh-1 text-16 text-light-1">Vergi Numarası <span class="text-red-1">*</span></label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-input">
                  <input type="text" [(ngModel)]="corpInvoice.companyCity" [ngModelOptions]="{standalone: true}">
                  <label class="lh-1 text-16 text-light-1">İl</label>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-input">
                  <input type="text" [(ngModel)]="corpInvoice.companyAddress" [ngModelOptions]="{standalone: true}">
                  <label class="lh-1 text-16 text-light-1">Adres</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-input">
                  <input type="tel" [(ngModel)]="corpInvoice.companyPhoneNumber" [ngModelOptions]="{standalone: true}">
                  <label class="lh-1 text-16 text-light-1">Telefon</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-input">
                  <input type="email" [(ngModel)]="corpInvoice.companyEmail" [ngModelOptions]="{standalone: true}">
                  <label class="lh-1 text-16 text-light-1">E-Posta</label>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Not -->
        <div class="form-section">
          <div class="form-section__header">
            <div class="form-section__icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            </div>
            <div>
              <h3 class="form-section__title">Ek Notlar</h3>
              <p class="form-section__desc">Otele iletmek istediğiniz özel talepleriniz varsa yazabilirsiniz.</p>
            </div>
          </div>
          <div class="form-input">
            <textarea formControlName="note" rows="3" placeholder="Örn: Yüksek kat tercih ediyoruz, erken check-in..."></textarea>
          </div>
        </div>

        <!-- Sözleşme -->
        <div class="form-section">
          <div class="d-flex items-center">
            <label class="form-checkbox-container" [class.form-checkbox-container--disabled]="!(termsAccepted && privacyAccepted)">
              <input type="checkbox" formControlName="isAggreementRead" required (click)="onAgreementClick($event)">
              <span class="checkmark"></span>
            </label>
            <div class="text-15 ml-10">
              <span class="text-red-1">*</span>
              <a (click)="openTermsModal()" class="cursor-pointer text-blue-1">
                <i *ngIf="termsAccepted" class="icon-check text-12 mr-5"></i>Kullanım şartları
              </a> ve
              <a (click)="openPrivacyModal()" class="cursor-pointer text-blue-1">
                <i *ngIf="privacyAccepted" class="icon-check text-12 mr-5"></i>Gizlilik Politikasını
              </a> okudum, kabul ediyorum.
            </div>
          </div>
        </div>

        <!-- Hata Mesajı -->
        <div *ngIf="errorMessage" class="soft-alert soft-alert--inline">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span>{{ errorMessage }}</span>
        </div>

        <!-- Butonlar -->
        <div class="form-actions">
          <app-loading *ngIf="isLoading" [size]="'medium'" [message]="'Rezervasyon kontrol ediliyor...'"></app-loading>
          <div class="d-flex justify-between" *ngIf="!isLoading">
            <button type="button" class="button h-50 px-24 -blue-1 bg-blue-1-05 text-blue-1" (click)="goBack()">
              <i class="icon-arrow-left mr-10"></i>
              Geri Dön
            </button>
            <button type="submit" class="button h-50 px-24 -dark-1 text-white bg-blue-1">
              Ödemeye Devam Et
              <i class="icon-arrow-right ml-10"></i>
            </button>
          </div>
        </div>

      </form>
    </div>

    <!-- Sağ: Ek Hizmetler & Fiyat Sidebar -->
    <div class="col-xl-4 col-lg-5">
      <div class="booking-sidebar">

        <!-- Ek Hizmetler -->
        <div class="addons-card" *ngIf="addons.length > 0">
          <div class="addons-card__header">
            <span class="addons-card__title">Ek Hizmetler</span>
          </div>

          <div *ngIf="addonError" class="addons-error">
            <span>{{ addonError }}</span>
            <button (click)="addonError = null">&times;</button>
          </div>

          <div class="addons-list">
            <div *ngFor="let addon of addons; let last = last"
                 class="addon-item-wrap" [class.addon-item-wrap--last]="last">
              <div class="addon-item__header">
                <div class="addon-item__info">
                  <span class="addon-item__name">{{ addon.name }}</span>
                  <span *ngIf="addon.isRequired" class="addon-item__required">Zorunlu</span>
                </div>
                <span class="addon-item__price">
                  +{{ getAddonPrice(addon) | currency : 'TRY' : 'symbol' : '1.0-0' }}
                </span>
              </div>
              <div class="addon-passengers">
                <label *ngFor="let pk of addonPassengerKeys" class="addon-passenger-check"
                  [for]="'addon-' + addon.key + '-' + pk">
                  <input type="checkbox"
                    [id]="'addon-' + addon.key + '-' + pk"
                    [checked]="selectedAddonsByPassenger[addon.key]?.[pk]"
                    [disabled]="addon.isRequired || isAddonProcessing[addon.key + '_' + pk]"
                    (change)="toggleAddonForPassenger(addon.key, pk, $event)" />
                  <span class="addon-passenger-check__box">
                    <i class="icon-check text-10"></i>
                  </span>
                  <span class="addon-passenger-check__label">{{ getPassengerLabel2(pk) }}</span>
                  <span *ngIf="isAddonProcessing[addon.key + '_' + pk]" class="addon-item__spinner">
                    <span class="spinner-border spinner-border-sm text-blue-1"></span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>

<!-- Kullanım Şartları Modal -->
<div class="agreement-modal-overlay" *ngIf="showTermsModal" (click)="closeModals()">
  <div class="agreement-modal" (click)="$event.stopPropagation()">
    <div class="agreement-modal-header">
      <h3>Kullanım Sözleşmesi</h3>
      <button class="modal-close-btn" (click)="closeModals()">&times;</button>
    </div>
    <div class="agreement-modal-body">
      <h4>WEB SİTESİ KULLANIM KOŞULLARI: pusulatatil.com</h4>
      <p>Siteye erişiminizden veya siteyi kullanımınızdan önce lütfen bu sözleşmeyi dikkatle okuyunuz. Siteye erişmekle veya siteyi kullanmakla, aşağıda belirtilen şartlar ve hükümlerle bağlı olmayı kabul etmektesiniz. Eğer bu şartlar ve hükümlerle bağlı olmak istemezseniz, siteye erişmeyebilir veya siteyi kullanamayabilirsiniz ve böyle bir kullanıma başladıysanız kullanımı derhal durdurmalısınız. "pusulatatil.com" bu sözleşmede her zaman değişiklik yapabilir ve bu değişiklikler değiştirilmiş sözleşmenin siteye konulmasıyla derhal yürürlük kazanır. Siz bu değişikliklerden haberdar olmak amacıyla periyodik olarak sözleşmeyi gözden geçirmeyi kabul etmektesiniz ve siteye devam eden erişiminiz veya devam eden siteyi kullanımınız değiştirilmiş sözleşmeyi kesin olarak kabul ettiğiniz anlamına gelecektir.</p>
      <h4>1. Ticari Markalar, Fikri Mülkiyet, Telif Hakları</h4>
      <p>pusulatatil.com sitesinin tüm hakları Pusula Tatil A.Ş'ye aittir. Bu web sayfalarında yayımlanan içerikler (örneğin yazılım, ürünler, logolar, v.s. gibi ticari markalar, bilgiler, raporlar, resimler ve grafikler), ulusal ve uluslar arası kanunlar ve uluslar arası sözleşmeler ile korunmaktadır.</p>
      <h4>2. Kullanım Koşullarının Değiştirilmesi</h4>
      <p>pusulatatil.com'un herhangi bir sebep göstermeksizin ve önce veya sonra ihbarda bulunmaksızın bu kullanım koşullarını değiştirme, ilavede bulunma veya yenileme hakkı saklıdır.</p>
      <h4>3. Hak ve Sorumluluklar</h4>
      <p>pusulatatil.com sitesine bulunan içerikler sürekli kontrol edilmekte ve güncellenmektedir. Ancak, pusulatatil.com ve sahibi Pusula Tatil A.Ş. site içeriğindeki bilgi ve fiyat hatalarından sorumlu tutulamaz.</p>
    </div>
    <div class="agreement-modal-footer">
      <button class="button -md -blue-1 bg-dark-1 text-white" (click)="acceptTerms()">
        <i class="icon-check mr-10"></i> Okudum, Onaylıyorum
      </button>
    </div>
  </div>
</div>

<!-- Gizlilik Politikası Modal -->
<div class="agreement-modal-overlay" *ngIf="showPrivacyModal" (click)="closeModals()">
  <div class="agreement-modal" (click)="$event.stopPropagation()">
    <div class="agreement-modal-header">
      <h3>Gizlilik Politikası</h3>
      <button class="modal-close-btn" (click)="closeModals()">&times;</button>
    </div>
    <div class="agreement-modal-body">
      <h4>1. Kişisel Verilerin Korunması</h4>
      <p>Kişisel verileriniz 6698 sayılı KVKK kapsamında korunmaktadır. Verileriniz yalnızca rezervasyon işlemleri için kullanılır.</p>
      <h4>2. Veri Toplama</h4>
      <p>Ad, soyad, e-posta, telefon ve adres bilgileriniz rezervasyon sürecinde toplanır ve güvenli şekilde saklanır.</p>
      <h4>3. Veri Paylaşımı</h4>
      <p>Kişisel verileriniz, rezervasyon yapılan otel ve ödeme kuruluşları dışında üçüncü taraflarla paylaşılmaz.</p>
      <h4>4. Çerezler</h4>
      <p>Sitemiz, kullanıcı deneyimini iyileştirmek için çerez kullanmaktadır. Tarayıcı ayarlarınızdan çerezleri yönetebilirsiniz.</p>
      <h4>5. Haklarınız</h4>
      <p>KVKK kapsamında verilerinize erişim, düzeltme ve silme haklarına sahipsiniz. Talepleriniz için bizimle iletişime geçebilirsiniz.</p>
    </div>
    <div class="agreement-modal-footer">
      <button class="button -md -blue-1 bg-dark-1 text-white" (click)="acceptPrivacy()">
        <i class="icon-check mr-10"></i> Okudum, Onaylıyorum
      </button>
    </div>
  </div>
</div>
